import { render, staticRenderFns } from "./VCandidateServicesBrowse.vue?vue&type=template&id=2dd0120a&lang=pug"
import script from "./VCandidateServicesBrowse.vue?vue&type=script&lang=ts"
export * from "./VCandidateServicesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VCandidateServicesBrowse.vue?vue&type=style&index=0&id=2dd0120a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ServicesBrowse.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FBrowse%2FVCandidateServicesBrowse.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports